// v2 API version
export interface AttomProperty {
  PRODUCT_INFO_ext: {
    ReportID_ext: string;
    ReportDescription_ext: string;
    Product_ext: string;
    RecordNumber_ext: number;
    MappingVersion_ext: string;
  };
  COMPARABLE_PROPERTY_ext: {
    '@_Sequence': string;
    '@DistanceFromSubjectPropertyMilesCount': string;
    '@_City': string;
    '@_StreetAddress': string;
    '@_State': string;
    '@_PostalCode': string;
    '@StandardUseCode_ext': string;
    '@StandardUseDescription_ext': string;
    '@SiteMailAddressSameIndicator_ext': string;
    '@LatitudeNumber': string;
    '@LongitudeNumber': string;
    STRUCTURE: {
      '@TotalBathroomCount': string;
      '@TotalBedroomCount': string;
      '@TotalBathroomFullCount_ext': string;
      '@TotalBathroomHalfCount_ext': string;
      '@TotalBathroomQuarterCount_ext': string;
      '@TotalBathroomThreeQuarterCount_ext': string;
      '@TotalRoomCount': string;
      '@StoriesCount': string;
      '@LivingUnitCount': string;
      '@GrossLivingAreaSquareFeetCount': string;
      '@TotalBathroomCountDq_ext': string;
      STRUCTURE_ANALYSIS: {
        '@PropertyStructureBuiltYear': string;
      };
    };
    SITE: {
      '@DepthFeetCount': string;
      '@LotSquareFeetCount': string;
      '@WidthFeetCount': string;
      '@PropertyZoningCategoryType': string;
    };
    SALES_HISTORY: {
      '@TransferDate_ext': string;
      '@FullOrPartialTransferValueType_ext': string;
      '@PropertySalesAmount': string;
      '@BuyerUnparsedName_ext': string;
      '@SellerUnparsedName': string;
      '@MultipleApnIndicator_ext': string;
      '@ArmsLengthTransactionIndicatorExt': string;
      '@PricePerSquareFootAmount': string;
    };
  };
}

export interface AttomResponseType {
  RESPONSE_GROUP: {
    RESPONDING_PARTY: {
      '@_Name': string;
      '@_StreetAddress': string;
      '@_City': string;
      '@_State': string;
      '@_PostalCode': string;
    };
    RESPONSE: {
      ResponseDateTime: string;
      KEY: {
        _Name: string;
        _Value: string;
      };
      RESPONSE_DATA: {
        PROPERTY_INFORMATION_RESPONSE_ext: {
          SUBJECT_PROPERTY_ext: {
            PROPERTY: AttomProperty[];
          };
        };
      };
    };
    PRODUCT: {
      STATUS: {
        _Code: number;
        _Condition: string;
        _Name: string;
        _Description: string;
      };
    };
  };
  ECHOED_FIELDS_ext: {
    '@JobID': string;
    '@LoanNumber': string;
    '@PreparedBy': string;
    '@ResellerID': string;
    '@PreparedFor': string;
  };
}

export interface AttomPropertyV1 {
  status: {
    version: string;
    code: number;
    msg: string;
    total: number;
    page: number;
    pagesize: number;
    transactionID: string;
  };
  property: [
    {
      identifier: {
        Id: number;
        fips: string;
        apn: string;
        attomId: number;
      };
      lot: {
        lotnum: string;
        lotsize1: number;
        lotsize2: number;
        pooltype: string;
      };
      area: {
        blockNum: string;
        loctype: string;
        countrysecsubd: string;
        countyuse1: string;
        muncode: string;
        munname: string;
        subdname: string;
        taxcodearea: string;
      };
      address: {
        country: string;
        countrySubd: string;
        line1: string;
        line2: string;
        locality: string;
        matchCode: string;
        oneLine: string;
        postal1: string;
        postal2: string;
        postal3: string;
      };
      location: {
        accuracy: string;
        latitude: string;
        longitude: string;
        distance: number;
        geoid: string;
        geoIdV4: {
          ZI: string;
          CS: string;
        };
      };
      summary: {
        absenteeInd: string;
        propclass: string;
        propsubtype: string;
        proptype: string;
        yearbuilt: number;
        propLandUse: string;
        propIndicator: string;
        legal1: string;
      };
      utilities: {};
      building: {
        size: {
          bldgsize: number;
          grosssize: number;
          grosssizeadjusted: number;
          livingsize: number;
          sizeInd: string;
          universalsize: number;
        };
        rooms: {};
        interior: {};
        construction: {
          constructiontype: string;
          frameType: string;
          wallType: string;
        };
        parking: {
          garagetype: string;
          prkgSpaces: string;
          prkgType: string;
        };
        summary: {
          archStyle: string;
          levels: number;
          quality: string;
          view: string;
        };
      };
      vintage: {
        lastModified: string;
        pubDate: string;
      };
    }
  ];
}
